// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1uBPJ","left":"StickyBox_left__1KOZp","right":"StickyBox_right__1xpS7"};